// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1380":"977750b2","4865":"99c2bedd","7442":"83fcf592","8264":"755754e0"}[chunkId] + ".chunk.css");